export default "__VITE_ASSET__Ddb220bC__"